<template>
	<transition name="el-zoom-in-top">
		<div class="content-wrapper">
			<!-- Content Header (Page header) -->
			<section class="content-header">
				<!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
				<ol class="breadcrumb">
					<li>
						<router-link to="/">
							<i class="ti-home"></i>
						</router-link>
					</li>
					<li>
						<a href="#/toko">Toko</a>
					</li>
					<li>
						<a href="#/penjualan">Penjualan</a>
					</li>
				</ol>
			</section>
			<!-- Main content -->
			<section class="content">
				<!-- Basic Tables-->
				<div class="box">
					<div class="box-header with-border">
            <div class="pull-left" style="padding-left: 20px; padding-top: 10px;">
              <h4>
                <b>PENJUALAN</b> <b v-if="this.data">{{this.nama_toko}}</b>
                <br/>
                <!-- <i v-if="this.data">periode {{this.value6.toString().substr(0, 10)}} s/d {{this.value6.toString().substr(11, 10)}}</i> -->
                <i v-if="this.data">periode {{this.tanggal1}} s/d {{this.tanggal2}}</i>
              </h4>
            </div>
            <div class="pull-right" style="padding-right: 20px; padding-top: 5px;">
              <!-- <el-select v-model="toko1" clearable filterable placeholder="Pilih Toko" style="width: 500px"
                  @change="handleSelect">
                <el-option
                  v-for="item in region"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
              <el-date-picker v-loading.fullscreen.lock="fullscreenLoading"
                style="width: 250px"
                type="daterange"
                align="right"
                v-model="value6"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="Awal"
                end-placeholder="Akhir">
              </el-date-picker>&nbsp;
              <el-button icon="el-icon-search" v-loading.fullscreen.lock="fullscreenLoading" @click="getData()" circle></el-button> -->
              <el-button icon="el-icon-search" v-loading.fullscreen.lock="fullscreenLoading" @click="filterDataPenjualan()" circle></el-button>
              <el-button type="primary" icon="{this.hitLapHarianIsActive === false ? el-icon-document : el-icon-loading}" v-loading.fullscreen.lock="fullscreenLoading" @click="getDataRawPenjualan()" size="medium" circle :disabled="this.summary_menu_excel.length < 1 || this.laporan_harian2.length < 1"></el-button>
            </div>
					</div>
					<div class="box-body">
					
				<el-row>
				  <el-col :span="24" style="padding: 5px">					       
						<div class="col-md-6 col-xl-6">
							<div class="box palette-Grey-200 bg">
								<!-- /.box-header -->
								<div class="box-body no-pad padding-fifthin" style="display: block;">
									<div class="events-nest ">
										<div class="wrap-no-pad padding-fifthin">
											<div class="row">
												<div class="col-sm-6 bor-right bor-bottom">
													<div class="devin-table-dash centered pad-box">
														<div class="palette-Pink-500 text value" v-if="data.sales">{{ data.sales.split(/ (.+)/)[1].replace(/\D/g, "") }}</div>
														<div class="label">Days</div>
													</div>
												</div>
												<div class="col-sm-6 bor-bottom">
													<div class="devin-table-dash centered pad-box">
														<div class="palette-Purple-500 text value" v-if="data.sales">{{ Math.round(parseFloat(data.avgNotDays) / parseFloat(data.sales.split(/ (.+)/)[1].replace(/\D/g, ""))) }}</div>
														<div class="label">Store</div>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-sm-6 bor-right">
													<div class="devin-table-dash centered pad-box">
														<div class="value palette-Deep-Purple-500 text">{{ data.not }}</div>
														<div class="label">NoT</div>
													</div>
												</div>
												<div class="col-sm-6">
													<div class="devin-table-dash centered pad-box">
														<div class="value palette-Light-Blue-500 text" v-if="data.sales"><strong>Rp </strong>{{ parseFloat(parseFloat(parseFloat(data.sales.split(/ (.+)/)[0].replace(/\D/g, "")) / 1000).toFixed(1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}<strong>K</strong></div>
														<div class="label">Sales Total</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 col-xl-6">
							<div class="box palette-Grey-200 bg">
								<!-- /.box-header -->
								<div class="box-body no-pad padding-fifthin" style="display: block;">
									<div class="events-nest ">
										<div class="wrap-no-pad padding-fifthin">
											<div class="row">
												<div class="col-sm-6 bor-right bor-bottom">
													<div class="devin-table-dash centered pad-box">
														<div class="palette-Pink-500 text value">{{ data.avgNotDays }}</div>
														<div class="label">Avg NoT/Days</div>
													</div>
												</div>
												<div class="col-sm-6 bor-bottom">
													<div class="devin-table-dash centered pad-box">
														<div class="palette-Purple-500 text value">{{ data.avgNotStore }}</div>
														<div class="label">Avg Sales/Days</div>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-sm-6 bor-right">
													<div class="devin-table-dash centered pad-box">
														<div class="value palette-Deep-Purple-500 text" v-if="data.avgSalesTransaction">{{ parseFloat(parseFloat(parseFloat(data.avgSalesTransaction.replace(/,/g, '')) / 1000).toFixed(1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}<strong>K</strong></div>
														<div class="label">Avg Sales/Transaction</div>
													</div>
												</div>
												<div class="col-sm-6">
													<div class="devin-table-dash centered pad-box">
														<div class="value palette-Light-Blue-500 text" v-if="data.avgSalesDays"><strong>Rp </strong>{{ parseFloat(parseFloat(parseFloat(data.avgSalesDays.replace(/,/g, '')) / 1000).toFixed(1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}<strong>K</strong></div>
														<div class="label">Avg NoT/Store/Days</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>       
				  </el-col>
				</el-row>
				
				<el-row>
				  <el-col :span="24" style="padding: 5px">
					<div class="box palette-Grey-500 bg">
						<div class="box-header palette-Grey-500 bg">
							<!-- tools box -->
							<!-- <div class="pull-right text-white box-tools">
								<span class="text-white box-btn">
								  <i class="circle-nest-medium dripicons-cart"></i>
								</span>&nbsp;&nbsp;&nbsp;
							</div> -->
							<h3 class="box-title">
							  <span class="text-white">&nbsp;&nbsp;&nbsp;Number of Transaction (NoT)</span>
							</h3>
						</div>
						<!-- /.box-header -->
						<div class="box-body no-pad" style="display: block; padding: 0px !important;">
							<div class="events-nest">
								<div class="wrap-no-pad text-white">
									<h2 style="color: white; word-break: break-all;" class="text-white">
									  <strong>{{ data.not }}</strong>
									</h2>
									<br>
								</div>
							</div>
						</div>
						<!-- /.box-body -->
					</div>
				  </el-col>
				  <el-col :span="24" style="padding: 5px">
					<div class="box palette-Grey-500 bg">
						<div class="box-header palette-Grey-500 bg">
							<!-- tools box -->
							<!-- <div class="pull-right text-white box-tools">
								<span class="text-white box-btn">
								  <i class="circle-nest-medium dripicons-cart"></i>
								</span>&nbsp;&nbsp;&nbsp;
							</div> -->
							<h3 class="box-title">
							  <span class="text-white">&nbsp;&nbsp;&nbsp;Sales Total</span>
							</h3>
						</div>
						<!-- /.box-header -->
						<div class="box-body no-pad" style="display: block; padding: 0px !important;">
							<div class="events-nest">
								<div class="wrap-no-pad text-white">
									<h2 style="color: white; word-break: break-all;" class="text-white">
									  <strong>{{ data.sales }}</strong>
									</h2>
									<br>
								</div>
							</div>
						</div>
						<!-- /.box-body -->
					</div>                
				  </el-col>
				</el-row>

				<el-row>
				  <el-col :span="24" style="padding: 5px">
					<div class="box palette-Grey-500 bg">
						<div class="box-header palette-Grey-500 bg">
							<!-- tools box -->
							<!-- <div class="pull-right text-white box-tools">
								<span class="text-white box-btn">
								  <i class="circle-nest-medium dripicons-cart"></i>
								</span>&nbsp;&nbsp;&nbsp;
							</div> -->
							<h3 class="box-title">
							  <span class="text-white">&nbsp;&nbsp;&nbsp;Average NoT / Day</span>
							</h3>
						</div>
						<!-- /.box-header -->
						<div class="box-body no-pad" style="display: block; padding: 0px !important;">
							<div class="events-nest">
								<div class="wrap-no-pad text-white">
									<h2 style="color: white; word-break: break-all;" class="text-white">
									  <strong>{{ data.avgNotDays }}</strong>
									</h2>
									<br>
								</div>
							</div>
						</div>
						<!-- /.box-body -->
					</div>
				  </el-col>
				  <el-col :span="24" style="padding: 5px">
					<div class="box palette-Grey-500 bg">
						<div class="box-header palette-Grey-500 bg">
							<!-- tools box -->
							<!-- <div class="pull-right text-white box-tools">
								<span class="text-white box-btn">
								  <i class="circle-nest-medium dripicons-cart"></i>
								</span>&nbsp;&nbsp;&nbsp;
							</div> -->
							<h3 class="box-title">
							  <span class="text-white">&nbsp;&nbsp;&nbsp;Average Sales / Day</span>
							</h3>
						</div>
						<!-- /.box-header -->
						<div class="box-body no-pad" style="display: block; padding: 0px !important;">
							<div class="events-nest">
								<div class="wrap-no-pad text-white">
									<h2 style="color: white; word-break: break-all;" class="text-white">
									  <strong>{{ data.avgSalesDays }}</strong>
									</h2>
									<br>
								</div>
							</div>
						</div>
						<!-- /.box-body -->
					</div>                
				  </el-col>
				  <el-col :span="24" style="padding: 5px">
					<div class="box palette-Grey-500 bg">
						<div class="box-header palette-Grey-500 bg">
							<!-- tools box -->
							<!-- <div class="pull-right text-white box-tools">
								<span class="text-white box-btn">
								  <i class="circle-nest-medium dripicons-cart"></i>
								</span>&nbsp;&nbsp;&nbsp;
							</div> -->
							<h3 class="box-title">
							  <span class="text-white">&nbsp;&nbsp;&nbsp;Average Sales / Transaction</span>
							</h3>
						</div>
						<!-- /.box-header -->
						<div class="box-body no-pad" style="display: block; padding: 0px !important;">
							<div class="events-nest">
								<div class="wrap-no-pad text-white">
									<h2 style="color: white; word-break: break-all;" class="text-white">
									  <strong>{{ data.avgSalesTransaction }}</strong>
									</h2>
									<br>
								</div>
							</div>
						</div>
						<!-- /.box-body -->
					</div>                
				  </el-col>
				</el-row>

				<el-row>
				  <el-col :span="24" style="padding: 5px">
					<div class="box palette-Grey-500 bg">
						<div class="box-header palette-Grey-500 bg">
							<!-- tools box -->
							<!-- <div class="pull-right text-white box-tools">
								<span class="text-white box-btn">
								  <i class="circle-nest-medium dripicons-cart"></i>
								</span>&nbsp;&nbsp;&nbsp;
							</div> -->
							<h3 class="box-title">
							  <span class="text-white">&nbsp;&nbsp;&nbsp;Average NoT / Store / Day</span>
							</h3>
						</div>
						<!-- /.box-header -->
						<div class="box-body no-pad" style="display: block; padding: 0px !important;">
							<div class="events-nest">
								<div class="wrap-no-pad text-white">
									<h2 style="color: white; word-break: break-all;" class="text-white">
									  <strong>{{ data.avgNotStore }}</strong>
									</h2>
									<br>
								</div>
							</div>
						</div>
						<!-- /.box-body -->
					</div>
				  </el-col>
				  <el-col :span="24" style="padding: 5px">
					<div class="box palette-Grey-500 bg">
						<div class="box-header palette-Grey-500 bg">
							<!-- tools box -->
							<!-- <div class="pull-right text-white box-tools">
								<span class="text-white box-btn">
								  <i class="circle-nest-medium dripicons-cart"></i>
								</span>&nbsp;&nbsp;&nbsp;
							</div> -->
							<h3 class="box-title">
							  <span class="text-white">&nbsp;&nbsp;&nbsp;Average Sales / Store / Day</span>
							</h3>
						</div>
						<!-- /.box-header -->
						<div class="box-body no-pad" style="display: block; padding: 0px !important;">
							<div class="events-nest">
								<div class="wrap-no-pad text-white">
									<h2 style="color: white; word-break: break-all;" class="text-white">
									  <strong>{{ data.avgSalesStore }}</strong>
									</h2>
									<br>
								</div>
							</div>
						</div>
						<!-- /.box-body -->
					</div>                
				  </el-col>
				</el-row>

				<!-- <br />

				<ve-line style="width:100%" :data="chartData" :settings="chartSettings"></ve-line> -->
	<!-- 
				<br />

				<line-chart :chartdata="chartDataa" :options="chartOptions"/> -->
				
				<el-row>
				  <el-col :span="24" style="padding: 5px">
					<div class="box palette-Grey-200 bg">
						<br />
						<!-- /.box-header -->
						<div class="box-body no-pad" style="display: block; padding: 0px !important;">
							<div class="events-nest">
								<div class="wrap-no-pad text-white">
									<ve-line style="width:100%" :data="chartData" :settings="chartSettings"></ve-line>
								</div>
							</div>
						</div>
						<!-- /.box-body -->
					</div>
				  </el-col>
				</el-row>

				<el-row>
				  <el-col :span="24" style="padding: 5px">
					<div class="box palette-Grey-200 bg">
						<br />
						<!-- /.box-header -->
						<div class="box-body no-pad" style="display: block; padding: 0px !important;">
							<div class="events-nest">
								<div class="wrap-no-pad text-white">
									<ve-histogram :data="barData" :settings="barSettings"></ve-histogram>
								</div>
							</div>
						</div>
						<!-- /.box-body -->
					</div>
				  </el-col>
				</el-row>

				<br />

						<el-tabs v-model="activeName" type="border-card">
							<el-tab-pane label="Berdasarkan Menu" name="menu">
								<el-table v-loading="loadingModal" border hover
                          :data="summary_menu"
                          style="width: 100%; padding-right: 1px;" 
                          max-height="410" responsive>
									<el-table-column fixed="left"
                            label="#"
                            header-align="center"
                            align="center"
                            width="50px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{scope.row.no}}.
                              </template>
										</template>
									</el-table-column>
									<el-table-column fixed="left"
                            label="MENU MASTER"
                            prop="menu_master"
                            header-align="left"
                            align="left">
										<template slot-scope="scope">
											<template v-if="scope.row.edit">
												<el-input v-model="cari_menu_master" placeholder="Filter Menu Master" @keyup.native="cariMenuMaster()"></el-input>
											</template>
											<span v-else>{{ scope.row.menu_master }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="left"
                            label="MENU TOKO"
                            prop="cari_menu_toko"
                            header-align="left"
                            align="left">
										<template slot-scope="scope">
											<template v-if="scope.row.edit">
												<el-input v-model="cari_menu_toko" placeholder="Filter Menu Toko" @keyup.native="cariMenuToko()"></el-input>
											</template>
											<span v-else>{{ scope.row.menu_toko }}</span>
										</template>
									</el-table-column>
									<el-table-column
                            label="QTY"
                            prop="qty"
                            header-align="center"
                            align="center"
                            width="100px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{toMoney(scope.row.qty)}}
                              </template>
										</template>
									</el-table-column>
									<el-table-column
                            label="RP"
                            prop="value"
                            header-align="center"
                            align="center"
                            width="130px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{toMoney(scope.row.value)}}
                              </template>
										</template>
									</el-table-column>
								</el-table>
							</el-tab-pane>
							<!-- <el-tab-pane label="Berdasarkan Transaksi" name="customer">
								<el-table v-loading="loadingModal" border hover
                          :data="tableData1"
                          style="width: 100%" max-height="360" responsive>
									<el-table-column fixed="left"
                            label="#"
                            header-align="center"
                            align="center"
                            width="50px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{scope.row.no}}.
                              </template>
										</template>
									</el-table-column>
									<el-table-column fixed="left"
                            label="TANGGAL SISTEM"
                            prop="tgl_sistem"
                            header-align="left"
                            align="left"
                            width="160px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{scope.row.tgl_sistem}}
                              </template>
										</template>
									</el-table-column>
									<el-table-column fixed="left"
                            label="TANGGAL POS"
                            prop="tgl_device"
                            header-align="left"
                            align="left"
                            width="160px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{scope.row.tgl_device}}
                              </template>
										</template>
									</el-table-column>
									<el-table-column
                            label="NOMOR"
                            prop="nomor_penjualan"
                            header-align="center"
                            align="center"
                            width="110px">
										<template slot-scope="scope">
											<template v-if="scope.row.edit">
												<el-input v-model="cari_nomor_penjualan" placeholder="Filter Nomor" @keyup.native="carinomor_Penjualan()"></el-input>
											</template>
											<span v-else>{{ scope.row.nomor_penjualan }}</span>
										</template>
									</el-table-column>
									<el-table-column
                            label="MENU"
                            prop="item"
                            header-align="center"
                            align="center"
                            width="130px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{toMoney(scope.row.item)}}
                              </template>
										</template>
									</el-table-column>
									<el-table-column
                            label="PEMBAYARAN"
                            prop="jenis"
                            header-align="center"
                            align="center"
                            width="130px">
										<template slot-scope="scope">
                      <template v-if="scope.row.edit">
                          <el-input v-model="cari_jenis" placeholder="Filter" @keyup.native="cariJenis()"></el-input>
                        </template>
                        <span v-else>{{ scope.row.jenis }}</span>
										</template>
									</el-table-column>
									<el-table-column
                            label="TOTAL"
                            prop="total"
                            header-align="left"
                            align="left">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{toMoney(scope.row.total)}}
                              </template>
										</template>
									</el-table-column>
									<el-table-column
                            label="STATUS"
                            prop="stat"
                            header-align="center"
                            align="center"
                            width="130px">
										<template slot-scope="scope">
                      <template v-if="scope.row.edit">
                          <el-input v-model="cari_stat" placeholder="Filter" @keyup.native="cariStat()"></el-input>
                        </template>
                        <span v-else>{{ scope.row.stat }}</span>
										</template>
									</el-table-column>
									<el-table-column label="PILIHAN" align="center" header-align="center" width="100px">
										<template slot-scope="scope">
											<el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Ok" placement="top-start">
												<el-button type="success" size="small" icon="el-icon-check"  @click="confirmEdit1(scope.$index, scope.row, ('form' + scope.$index))"></el-button>
											</el-tooltip>
											<el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Detail" placement="top-start">
												<el-button type="primary" icon="el-icon-search" size="small" @click="confirmDet(scope.row)"></el-button>
											</el-tooltip>
											<el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Cancel" placement="top-start">
												<el-button size="small" icon="el-icon-error" type="warning" @click="cancelEdit(scope.$index, scope.row)"></el-button>
											</el-tooltip>
										</template>
									</el-table-column>
								</el-table>
								<br/>
							</el-tab-pane> -->
							<el-tab-pane label="Berdasarkan Stok Qty" name="barang">
								<el-table v-loading="loadingModal" border hover
                          :data="laporan_harian"
                          style="width: 100%; padding-right: 1px;" max-height="410" responsive>
									<el-table-column fixed="left"
                            label="#"
                            header-align="center"
                            align="center"
                            width="50px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{scope.row.no}}.
                              </template>
										</template>
									</el-table-column>
									<el-table-column fixed="left"
                            label="BARANG"
                            prop="nama"
                            header-align="left"
                            align="left">
										<template slot-scope="scope">
											<template v-if="scope.row.edit">
												<el-input v-model="cari_barang" placeholder="Filter Menu Master" @keyup.native="cariBarang()"></el-input>
											</template>
											<span v-else>{{ scope.row.nama }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="left"
                            label="PAKET"
                            prop="paket"
                            header-align="center"
                            align="center"
                            width="130px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{toMoney(scope.row.paket)}}
                              </template>
										</template>
									</el-table-column>
									<el-table-column
                            label="NON PAKET"
                            prop="nonpaket"
                            header-align="center"
                            align="center"
                            width="130px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{toMoney(scope.row.nonpaket)}}
                              </template>
										</template>
									</el-table-column>
									<el-table-column
                            label="WASTE"
                            prop="ttlwaste"
                            header-align="center"
                            align="center"
                            width="130px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{toMoney(scope.row.ttlwaste)}}
                              </template>
										</template>
									</el-table-column>
									<el-table-column
                            label="TOTAL"
                            prop="total"
                            header-align="center"
                            align="center"
                            width="130px">
										<template slot-scope="scope">
											<template v-if="!scope.row.edit">
                                {{toMoney(scope.row.total)}}
                              </template>
										</template>
									</el-table-column>
								</el-table>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
				<el-dialog title="Filter Data Penjualan" :visible.sync="dialogFormFilter" v-loading="loadingModalFilter" :close-on-click-modal="false" width="99%" top="1%">
          <el-form status-icon :rules="rules3" ref="formFilter" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
            <el-form-item label="Pilih Region" prop="region" v-if="this.region.length > 0">
							<el-select v-model="regionSelected" clearable filterable placeholder="Pilih Region" style="width: 100%" @change="cbPilihRegion">
                <el-option
                  v-for="item in region"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
						</el-form-item>
            <el-form-item label="Pilih Wilayah" prop="wilayah" v-if="this.wilayah.length > 0">
							<el-select v-model="wilayahSelected" clearable filterable placeholder="Pilih Wilayah" style="width: 100%" @change="cbPilihWilayah">
                <el-option
                  v-for="item in wilayah"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
						</el-form-item>
            <el-form-item label="Pilih Area" prop="area" v-if="this.area.length > 0">
							<el-select v-model="areaSelected" clearable filterable placeholder="Pilih Area" style="width: 100%" @change="cbPilihArea">
                <el-option
                  v-for="item in area"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
						</el-form-item>
            <el-form-item label="Pilih Cabang" prop="cabang" v-if="this.cabang.length > 0">
							<el-select v-model="cabangSelected" clearable filterable placeholder="Pilih Cabang" style="width: 100%" @change="cbPilihCabang">
                <el-option
                  v-for="item in cabang"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
						</el-form-item>
						<el-form-item label="Pilih Toko" prop="toko" v-if="this.toko.length > 0">
							<el-select v-model="tokoSelected" clearable filterable placeholder="Pilih Toko" style="width: 100%" @change="cbPilihToko">
                <el-option
                  v-for="item in toko"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
						</el-form-item>
						<!-- <el-form-item label="Periode" prop="tanggal">
							<el-date-picker
                style="width: 250px"
                type="daterange"
                align="right"
                v-model="value6"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="Awal"
                end-placeholder="Akhir">
              </el-date-picker>
						</el-form-item>             -->
						<el-form-item label="Tanggal Awal" prop="tanggal1">
							<el-date-picker
                style="width: 150px"
                type="date"
                align="left"
                v-model="value4"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
						</el-form-item>
						<el-form-item label="Tanggal Akhir" prop="tanggal2">
							<el-date-picker
                style="width: 150px"
                type="date"
                align="left"
                v-model="value5"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<!-- <el-button @click="dialogFormFilter = false">Batal</el-button> -->
						<el-button @click="batal()">Batal</el-button>
						<el-button type="primary" @click="getData()" v-if="this.kode_toko.length > 0">Tampilkan</el-button>
					</span>
				</el-dialog>
				<el-dialog title="Konfirmasi" :visible.sync="dialogFormLunas" v-loading="loadingModalLunas" width="35%">
					<h4>Apakah Anda yakin akan melakukan pelunasan tanggal {{tanggal}}-{{bulan}}-{{tahun}} sebesar Rp {{toMoney(nominal)}} ?</h4>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogFormLunas = false">Batal</el-button>
						<el-button type="primary" @click="confirmLunas1()">Ya</el-button>
					</span>
				</el-dialog>
				<el-dialog title="Tambah Saving" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd" width="35%">
					<el-form :model="row1" status-icon :rules="rules3" ref="formAdd" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
						<el-form-item label="Tanggal" prop="tanggal">
							<el-date-picker
                        v-model="row1.tanggal"
                        type="date"></el-date-picker>
						</el-form-item>
						<el-form-item label="Keterangan" prop="nama">
							<el-select v-model="row1.nama" placeholder="Pilih Keterangan" style="width: 300px" >
								<el-option
                          v-for="item in namas"
                          :key="item.kode"
                          :label="item.nama"
                          :value="item.nama"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Jumlah" prop="jumlah">
							<el-input type="text" v-model="row1.jumlah" auto-complete="off"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogFormVisible = false">Batal</el-button>
						<el-button type="primary" @click="confirmEdit1(0, row1, 'formAdd')">Simpan</el-button>
					</span>
				</el-dialog>
				<el-dialog title="Edit Wilayah" :visible.sync="dialogFormEdit" v-loading="loadingModalEdit" width="35%">
					<el-form :model="row1" status-icon :rules="rules3" ref="formEdit" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
						<el-form-item label="Nama" prop="nama">
							<el-input type="text" v-model="row1.nama" auto-complete="off"></el-input>
						</el-form-item>
						<el-form-item label="Jumlah" prop="jumlah">
							<el-input type="text" v-model="row1.jumlah" auto-complete="off"></el-input>
						</el-form-item>
						<el-form-item label="Tanggal" prop="tanggal">
							<el-date-picker
                        v-model="row1.tanggal"
                        type="date"></el-date-picker>
						</el-form-item>
					</el-form>
					<el-table v-loading="loadingModalAdmin" border hover
                    :data="pegawai"
                      highlight-current-row
                      @current-change="handleCurrentChangePegawai"
                    style="width: 100%" responsive>
						<el-table-column fixed="left"
                      label="#"
                      min-width="50">
							<template slot-scope="scope">
                          {{scope.$index + 1}}
                      </template>
						</el-table-column>
						<el-table-column fixed="left"
                      label="SKU"
                      min-width="300">
							<template slot-scope="scope">
                          {{scope.row.sku}}
                      </template>
						</el-table-column>
						<el-table-column fixed="left"
                      label="Nama"
                      min-width="300">
							<template slot-scope="scope">
                          {{scope.row.nama}}
                      </template>
						</el-table-column>
					</el-table>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogFormEdit = false">Batal</el-button>
						<el-button type="primary" @click="confirmEdit1(0, row1, 'formEdit')">Simpan</el-button>
					</span>
				</el-dialog>
				<el-dialog :title="'Detail Transaksi #' + nomor_penjualan" :visible.sync="dialogDet" v-loading="loadingModalDet" width="700px" top="1%">
					<el-table
                    :data="tableData7"
                    style="width: 100%" responsive>
						<el-table-column
                      label="MENU"
                      prop="menu"
                      header-align="left"
                      align="left"></el-table-column>
						<el-table-column
                      label="QTY"
                      prop="qty"
                      header-align="center"
                      align="center"
                      width="100px">
							<template slot-scope="scope">
								<span>{{ toMoney(scope.row.qty) }}</span>
							</template>
						</el-table-column>
						<el-table-column
                      label="HARGA"
                      prop="harga_satuan"
                      header-align="center"
                      align="center"
                      width="150px">
							<template slot-scope="scope">
								<span>{{ toMoney(scope.row.harga_satuan) }}</span>
							</template>
						</el-table-column>
						<el-table-column
                      label="TOTAL"
                      prop="total"
                      header-align="center"
                      align="center"
                      width="150px">
							<template slot-scope="scope">
								<span>{{ toMoney(scope.row.total) }}</span>
							</template>
						</el-table-column>
					</el-table>
					<span slot="footer" class="dialog-footer">
						<el-button type="primary" size="small" @click="dialogDet = false">TUTUP</el-button>
					</span>
				</el-dialog>
				<el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel" width="35%">
					<h4>Apakah Anda yakin akan menghapus {{ nama }}?</h4>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogFormWilDel = false">Batal</el-button>
						<el-button type="primary" @click="confirmDel1()">Ya</el-button>
					</span>
				</el-dialog>
				<el-dialog title="Info" :visible.sync="dialogFormInfo" width="35%">
					<h5>{{message}}</h5>
					<span slot="footer" class="dialog-footer">
						<!-- <el-button @click="dialogFormInfo = false">Batal</el-button> -->
						<el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
					</span>
				</el-dialog>
				<!-- End of Basic Tables-->
			</section>
			<!-- /.content -->
		</div>
	</transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import VueCookie from 'vue-cookie'
    import moment from 'moment'
    import JsonExcel from 'vue-json-excel/JsonExcel.vue'
    import { Bar } from 'vue-chartjs'
    
    Vue.use(VueCookie)

    import jsonUrl from '../../../assets/url.json'

    Vue.use(VueResource)

    import XLSX from 'xlsx'

    export default {
      extends: Bar,
      name: 'Wilayah',
      components: {
        ClipLoader,
        JsonExcel
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          toko1: '',
          regionSelected: '',
          wilayahSelected: '',
          areaSelected: '',
          cabangSelected: '',
          tokoSelected: '',
          filter_nama_toko: '',
          value4: new Date(),
          value5: new Date(),
          value6: '',
          value14: '',
          nomor_penjualan: '',
          bulan: '',
          tahun: '',
          row1: {kode: '', nama: '', edit: true},
          tableData: [],
          tableData1: [],
          tableData2: [],
          tableData3: [],
          cData: [],
          summary_menu: [],
          summary_menu1: [],
          summary_menu_excel: [],
          laporan_harian: [],
          laporan_harian1: [],
          laporan_harian2: [],
          raw_penjualan: [],
          excel: [],
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          chartData: {
            columns: ['Linex', 'Sales'],
            rows: []
          },
          chartSettings: {
            stack: { 'Price': ['Sales'] },
            area: true
          },
          barData: {
            columns: ['label', 'omset', 'cost'],
            rows: []
          },
          barSettings: {},
          colorList: [],
          data: '',
          tanggal1: '',
          tanggal2: '',
          cari_menu_master: '',
          cari_menu_toko: '',
          cari_qty: '',
          cari_value: '',
          cari_nomor_penjualan: '',
          cari_tgl_sistem: '',
          cari_total: '',
          cari_item: '',
          cari_jenis: '',
          cari_stat: '',
          nama: '',
          tanggal: '',
          nominal: '',
          kode_region: '',
          kode_wilayah: '',
          kode_area: '',
          kode_cabang: '',
          kode_toko: '',
          region: [],
          wilayah: [],
          area: [],
          cabang: [],
          toko: [],
          namas: [],
          pegawai: [],
          coba: false,
          dialogFormEdit: false,
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          dialogFormInfo: false,
          dialogFormLunas: false,
          loadingModalLunas: false,
          loadingModalDet: false,
          dialogDet: false,
          loadingModalFilter: false,
          dialogFormFilter: false,
          activeName: 'menu',
          fullscreenLoading: false,
          form: {
            kode: '',
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          message: '',
          formLabelWidth: 'auto',
          rules3: {
            nama: [
              { required: true, message: 'Silahkan isi nama device', trigger: 'blur' }
            ]
          },
          listQuery: {
            page: 1,
            limit: 20,
            importance: undefined,
            title: undefined,
            type: undefined,
            sort: 'none'
          },
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Nama A-Z', key: '+nama' }, { label: 'Nama Z-A', key: '-nama' }],
          total: null,
          page_size: 6,
          current_page: 1,
          chartDataa: {
            labels: ['January', 'February'],
            datasets: [
              {
                label: 'Data One',
                backgroundColor: '#f87979',
                data: [40, 20]
              }
            ]
          },
          chartOptions: {
            responsive: true,
            maintainAspectRatio: false
          }
        }
      },
      methods: {
        getNow: function () {
          const today = new Date()
          const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
          const time = today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds()
          const dateTime = date + ' ' + time
          return dateTime
        },
        filterDataPenjualan: function () {
          this.dialogFormFilter = true
        },
        getDataRawPenjualan: function () {
          this.fullscreenLoading = true
          var tanggalFilter = this.value14
          var range = []
          // var startDate = this.value6.toString().substr(0, 10)
          // var endDate = this.value6.toString().substr(11, 10)
          var startDate = moment(this.value4).format('YYYY-MM-DD')
          var endDate = moment(this.value5).format('YYYY-MM-DD')
          var dateMove = new Date(startDate)
          strDate = startDate

          if (strDate < endDate) {
            while (strDate < endDate) {
              var strDate = dateMove.toISOString().slice(0, 10)
              range.push(strDate)
              dateMove.setDate(dateMove.getDate() + 1)
            }
          } else {
            range.push(strDate)
          }
          tanggalFilter = range

          // var req = {kode_toko: this.kode_toko.replace(/[^0-9]/g, ''), tanggal_filter: tanggalFilter}
          var req = {kode_toko: this.kode_toko, tanggal_filter: tanggalFilter}
          var req1 = JSON.stringify(req)

          this.raw_penjualan = []
          var url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/raw'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              // this.fullscreenLoading = false
              // this.raw_penjualan = JSON.stringify(response.body.data.slice())
              // this.downloadExcel()
              this.$notify.info({
                title: 'Download',
                message: 'Data penjualan ' + this.nama_toko + ' sedang diproses',
                offset: 100,
                duration: 1000,
                showClose: false
              })

              var self = this
              setTimeout(function () {
                console.log(response.body.data)
                self.fullscreenLoading = false
                self.raw_penjualan = JSON.stringify(response.body.data.slice())
                self.downloadExcel()
              }, 100)
            }
          }, response => {
            // error callback
            this.fullscreenLoading = false
          })
        },
        downloadExcel: function () {
          try {
            /* eslint-disable */
            /* make the worksheet */
            var jsonData3 = JSON.parse(this.laporan_harian2)

            var newJsonData3 = jsonData3.map(el => ({
              barang: el.nama,
              paket: el.paket,
              nonpaket: el.nonpaket,
              waste: el.ttlwaste,
              total: el.total
              // return el
            }))

            var self = this
            setTimeout(function () {

              var ws = XLSX.utils.json_to_sheet(JSON.parse(self.summary_menu_excel));
              var ws1 = XLSX.utils.json_to_sheet(JSON.parse(self.raw_penjualan));
              var ws2 = XLSX.utils.json_to_sheet(newJsonData3);
              // var ws3 = XLSX.utils.json_to_sheet(JSON.parse(this.raw_penjualan));

              /* add to workbook */
              var wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, ws, "Berdasarkan Menu");
              XLSX.utils.book_append_sheet(wb, ws1, "Berdasarkan Penjualan");
              XLSX.utils.book_append_sheet(wb, ws2, "Berdasarkan Stok Qty");
              // XLSX.utils.book_append_sheet(wb, ws3, "Raw Penjualan");

              /* generate an XLSX file */
              // XLSX.writeFile(wb, 'PENJUALAN_' + this.toko1 + '_' + this.tanggal + '-' + this.bulan + '-' + this.tahun + '_sd_' + this.tanggal2 + '-' + this.bulan2 + '-' + this.tahun2+'.xlsx');
              XLSX.writeFile(wb, 'PENJUALAN_' + self.nama_toko +'.xlsx');
              
              // XLSX.writeFile(wb, 'PENJUALAN_' + getNow() + '.xlsx');
              // XLSX.writeFile(wb, 'PENJUALAN.xlsx');
              /* eslint-disable */
              
              self.$notify.success({
                title: 'Sukses',
                message: 'File data penjualan ' + self.nama_toko + ' sudah didownload',
                offset: 100,
                duration: 0
              });
            }, 100)

          } catch (error) {
            console.log('yah error');
            console.log(error);
          }
        },
        cleared () {
          var queryString = ''
          var links = this.region.slice()
          var results = queryString ? links.filter(this.createFilter(queryString)) : links
          cb(results)
        },
        querySearch: function (queryString, cb) {
          var links = this.region.slice()
          var results = queryString ? links.filter(this.createFilter(queryString)) : links
          cb(results)
        },
        createFilter (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelect (item) {          
          this.nama_toko = item.label
          this.kode_toko = item.value
          // this.getData()
        },
        cbPilihRegion (item) {
          this.kode_toko = ''
          this.wilayah = []
          this.area = []
          this.cabang = []
          this.toko = []
          if (item.label.toString().indexOf('SEMUA TOKO') > -1) {
            this.nama_toko = item.label
            this.kode_toko = item.value
          } else {
            this.kode_region = item.value
            this.getDataWilayah()
            this.kode_area = ''
            this.kode_cabang = ''
            this.kode_toko = ''
          }
        },
        cbPilihWilayah (item) {
          this.kode_toko = ''
          this.area = []
          this.cabang = []
          this.toko = []
          console.log(item.value)
          if (item.label.toString().indexOf('SEMUA TOKO') > -1) {
            this.nama_toko = item.label
            this.kode_toko = item.value
          } else {
            this.kode_wilayah = item.value
            this.getDataArea()
            this.kode_cabang = ''
            this.kode_toko = ''
          }
        },
        cbPilihArea (item) {
          this.kode_toko = ''
          this.cabang = []
          this.toko = []
          console.log(item.label)
          if (item.label.toString().indexOf('SEMUA TOKO') > -1) {
            this.nama_toko = item.label
            this.kode_toko = item.value
          } else {
            this.kode_area = item.value
            this.getDataCabang()
            this.kode_toko = ''
          }
        },
        cbPilihCabang (item) {
          this.kode_toko = ''
          this.toko = []
          console.log(item.label)
          if (item.label.toString().indexOf('SEMUA TOKO') > -1) {
            this.nama_toko = item.label
            this.kode_toko = item.value
          } else {
            this.kode_cabang = item.value
            this.getDataToko()
          }
        },
        cbPilihToko (item) {
          this.nama_toko = item.label
          this.kode_toko = item.value
          // this.getDataToko()
        },
        toMoney (x) {
          var parts = x.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return parts.join('.')
        },
        confirmLunas: function (row) {
          this.dialogFormLunas = true
          this.tanggal = row.tanggal
          this.nominal = row.uang_setor
        },
        confirmLunas1: function () {
          this.loadingModalLunas = true

          var req = {kode_toko: this.kode_toko, bulan: this.bulan, tahun: this.tahun, tanggal: this.tanggal, nominal: this.nominal}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/setoran'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalLunas = false
              this.dialogFormLunas = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
            }
          }, response => {
            // error callback
            this.loadingModalLunas = false
            this.dialogFormLunas = false
          })
        },
        handleChangeDate: function () {
          this.tanggal1 = moment(this.value4).format('YYYY-MM-DD')
          this.getData()
        },
        handleChangeDate2: function () {
          this.tanggal2 = moment(this.value5).format('YYYY-MM-DD')
          this.getData()
        },
        handleCurrentChangePegawai (val) {
          this.row1.nama = val.nama
          this.row1.kode_menu = val.kode
        },
        cariMenuMaster () {
          var nama = this.cari_menu_master + ''
          var newArray = this.summary_menu1.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.menu_master + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.summary_menu = newArray1.slice()
          this.summary_menu.unshift({kode: '', edit: true, nama: ''})
          // this.handleCurrentChange(this.current_page)
        },
        cariMenuToko () {
          var nama = this.cari_menu_toko + ''
          var newArray = this.summary_menu1.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.menu_toko + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.summary_menu = newArray1.slice()
          this.summary_menu.unshift({kode: '', edit: true, nama: ''})
          // this.handleCurrentChange(this.current_page)
        },
        cariQty () {
          var nama = this.cari_qty + ''
          var newArray = this.summary_menu.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.qty + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.summary_menu = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariVvalue () {
          var nama = this.cari_value + ''
          var newArray = this.summary_menu.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.value + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.summary_menu = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        carinomor_Penjualan () {
          var nama = this.cari_nomor_penjualan + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nomor_penjualan + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        caritgl_sistem () {
          var nama = this.cari_tgl_sistem + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.tgl_sistem + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariTotal () {
          var nama = this.cari_total + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.total + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariItem () {
          var nama = this.cari_item + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.item + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariJenis () {
          var nama = this.cari_jenis + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.jenis + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariStat () {
          var nama = this.cari_stat + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.stat + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariBarang () {
          var nama = this.cari_barang + ''
          var newArray = this.laporan_harian1.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.laporan_harian = newArray1.slice()
          this.laporan_harian.unshift({kode: '', edit: true, nama: ''})
        },
        handleFilter () {
          var byNama = this.tableData.slice(0)
          if (this.listQuery.sort === '+nama') {
            byNama.sort(function (a, b) {
              var x = a.nomor_penjualan.toLowerCase()
              var y = b.nomor_penjualan.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.listQuery.sort === '-nama') {
            byNama.sort(function (a, b) {
              var x = b.nomor_penjualan.toLowerCase()
              var y = a.nomor_penjualan.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          this.tableData1.push({kode: '', edit: true, nama: ''})
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        submitForm: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!')
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        addData: function () {
          // this.tableData1.unshift({kode: '', nama: '', edit: true})
          this.dialogFormVisible = true
          this.clearForm()
        },
        clearForm: function () {
          this.row1 = {kode: '', nama: '', edit: true, tanggal_invoice: new Date(), tanggal: new Date()}
        },
        confirmEdit: function (j, row) {
          this.dialogFormEdit = true
          this.row1.kode = row.kode
          this.row1.nama = row.nama
          this.row1.id = row.id
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        confirmEdit1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (row.kode !== '') {
                this.loadingModalEdit = true
              } else {
                this.loadingModalAdd = true
              }
              this.dialogFormVisible = false
              this.dialogFormEdit = false

              var req = ''
              var action = '/'
              var tgl = moment(row.tanggal).format('YYYY-MM-DD')
              if (row.kode !== '') {
                req = {kode: row.kode, kode_toko: this.kode_toko, kode_menu: this.row1.kode_menu}
                action += 'update'
              } else {
                req = {kode_toko: this.kode_toko, nama: this.row1.nama, jumlah: this.row1.jumlah, tanggal: tgl}
                action += 'create'
              }
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEdit = false
                  this.loadingModalAdd = false
                  this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEdit = false
                this.loadingModalAdd = false
                this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nama
          this.dialogFormWilDel = true
        },
        confirmDel1: function () {
          this.loadingModalDel = true
          var req = {kode: this.form1.kode + '', kode_toko: this.kode_toko}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/delete'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormWilDel = false
              this.loadingModalDel = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        batal: function() {
          this.dialogFormFilter = false
        },
        getData: function () {
          
          console.log('kode toko = ', this.kode_toko)
          if (this.kode_toko === '') {
            return false
          }

          // if (this.value6 === '') {
          //   return false
          // }

          this.fullscreenLoading = true
          this.loadingModal = true
          this.laporan_harian = []
          this.tableData = []
          this.tableData1 = []
          this.summary_menu = []
          this.summary_menu_excel = []
          this.tanggal1 = moment(this.value4).format('YYYY-MM-DD')
          this.tanggal2 = moment(this.value5).format('YYYY-MM-DD')
          // this.tanggal = moment(this.value4).format('DD')
          this.bulan = moment(this.value4).format('MM')
          this.tahun = moment(this.value4).format('YYYY')
          var tanggalAwal = moment(this.value4).format('YYYY-MM-DD')
          // this.tanggal2 = moment(this.value5).format('DD')
          this.bulan2 = moment(this.value5).format('MM')
          this.tahun2 = moment(this.value5).format('YYYY')
          var tanggalAkhir = moment(this.value5).format('YYYY-MM-DD')
          var tanggalFilter = this.value14
          var tanggalRange = this.value6

          var range = []
          // var startDate = this.value6.toString().substr(0, 10)
          // var endDate = this.value6.toString().substr(11, 10)
          var startDate = moment(this.value4).format('YYYY-MM-DD')
          var endDate = moment(this.value5).format('YYYY-MM-DD')
          var dateMove = new Date(startDate)
          var strDate = startDate

          if (strDate < endDate) {
            while (strDate < endDate){
              var strDate = dateMove.toISOString().slice(0,10)
              range.push(strDate)
              dateMove.setDate(dateMove.getDate()+1)
            }
          } else {
            range.push(strDate)
          }

          tanggalFilter = range

          var c = this.current_page
          // var req = {kode_toko: this.kode_toko.replace(/[^0-9]/g, ''), tanggal_awal: tanggalAwal, tanggal_akhir: tanggalAkhir, tanggal_filter: tanggalFilter}
          var req = {kode_toko: this.kode_toko, tanggal_awal: tanggalAwal, tanggal_akhir: tanggalAkhir, tanggal_filter: tanggalFilter}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/readByDate'
          // Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
          //   // console.log('response ' + response.body[0].nama)
          //   if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
          //     this.$router.push('/login')
          //   } else {
          //     this.loadingModal = false
          //     // this.tableData = response.body.data.slice()
          //     this.tableData1 = response.body.data.slice()
          //     this.tableData3 = JSON.stringify(response.body.data.slice())
          //     this.total = this.tableData.length
          //     for (var i = 0; i < this.tableData.length; i++) {
          //       this.tableData[i].edit = false
          //       this.tableData[i].no = i + 1
          //     }
          //     this.tableData2 = this.tableData.slice()
          //     this.tableData.unshift({kode: '', edit: true, nama: ''})

              
          //     // var a = 0
          //     // var b = a + this.page_size
          //     // if (b > this.tableData.length) {
          //     //   b = this.tableData.length
          //     // }
          //     // for (var j = a; j < b; j++) {
          //     //   this.tableData1.push(this.tableData[j])
          //     // }
          //     // this.current_page = c
          //     // this.handleCurrentChange(c)
          //   }
          // }, response => {
          //   // error callback
          //   this.loadingModal = false
          // })

          this.loadingModal = false

          this.summary_menu = []
          url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/summary_menu'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.summary_menu_excel = JSON.stringify(response.body.data)
              this.summary_menu = response.body.data.slice()
              this.total = this.summary_menu.length
              for (var i = 0; i < this.summary_menu.length; i++) {
                this.summary_menu[i].edit = false
                this.summary_menu[i].no = i + 1
              }
              this.summary_menu1 = this.summary_menu.slice()
              this.summary_menu.unshift({kode: '', edit: true, nama: ''})
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })

          this.$notify({
            dangerouslyUseHTMLString: true,
            title: 'Perhatian',
            message: 'Secara otomatis sistem akan mengumpulkan data <b>Laporan Harian</b>, mohon menunggu hingga proses selesai',
            type: 'warning',
            offset: 100,
            duration: 0
          });
          this.laporan_harian = []
          this.laporan_harian2 = []
          url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/laporan_harian'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}, {timeout: 300, emulateJSON: true, emulateHTTP: true}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.laporan_harian = response.body.data.slice()
              this.laporan_harian2 = JSON.stringify(response.body.data.slice())
              this.total = this.laporan_harian.length
              for (var i = 0; i < this.laporan_harian.length; i++) {
                this.laporan_harian[i].edit = false
                this.laporan_harian[i].no = i + 1
              }
              this.laporan_harian1 = this.laporan_harian.slice()
              this.laporan_harian.unshift({kode: '', edit: true, nama: ''})
              this.$notify.success({
                dangerouslyUseHTMLString: true,
                title: 'Sukses',
                message: 'Data <b>Laporan Harian</b> sudah diterima',
                offset: 100,
                duration: 0
              });
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })

          this.data = []
          url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/dashboard'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.data = response.body.data[0]
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })

          this.chartData.rows = []
          url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/chart60'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              console.log('response.body.data=' + response.body.data.slice())
              this.chartData.rows = response.body.data.slice()
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })

          
          this.barData.rows = []
          url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/bar_sales_session'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              console.log('response.body.data=' + response.body.data.slice())
              this.barData.rows = response.body.data.slice()
            }
          }, response => {
            // error callback
            this.loadingModal = false  
          })
          
          setTimeout(() => {
            this.fullscreenLoading = false
            this.dialogFormFilter = false
          }, 3000)

          // url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/excel'
          // Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
          //   // console.log('response ' + response.body[0].nama)
          //   if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
          //     this.$router.push('/login')
          //   } else {
          //     this.loadingModal = false
          //     this.excel = response.body.data.slice()
          //   }
          // }, response => {
          //   // error callback
          //   this.loadingModal = false
          // })          
        },
        confirmDet: function (row) {
          this.dialogDet = true
          this.loadingModalDet = true
          this.nomor_penjualan = row.nomor_penjualan
          this.tableData7 = []
          var req = {kode_toko: this.kode_toko, nomor_penjualan: row.nomor_penjualan}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.penjualan + '/detail'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.tableData7 = response.body.data.slice()
              this.loadingModalDet = false
            }
          }, response => {
            // error callback
            this.loadingModalDet = false
          })
        },
        getDataRegion: function () {

          var kode = localStorage.kodeLevel

          var req = {kode: kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/region'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.region = response.body.data.slice()
              for (var i = 0; i < this.region.length; i++) {
                this.region[i].value = this.region[i].kode + ''
                this.region[i].label = this.region[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        },
        getDataWilayah: function () {
          // this.colorList = ['#e46c0b', '#c0504d', '#e46c0b', '#604a7b', '#948a54', '#e46c0b']
          // this.barSettings.itemStyle.normal = {color: (params) => {return this.colorList[params.dataIndex]}}
          var kode = localStorage.kodeLevel
          if (this.kode_region != '') {
            kode = this.kode_region
          }
          var req = {kode: kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/wilayah'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.wilayah = response.body.data.slice()
              for (var i = 0; i < this.wilayah.length; i++) {
                this.wilayah[i].value = this.wilayah[i].kode + ''
                this.wilayah[i].label = this.wilayah[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        },
        getDataArea: function () {

          var kode = localStorage.kodeLevel
          if (this.kode_wilayah != '') {
            kode = this.kode_wilayah
          }
          var req = {kode: kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/area'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.area = response.body.data.slice()
              for (var i = 0; i < this.area.length; i++) {
                this.area[i].value = this.area[i].kode + ''
                this.area[i].label = this.area[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        },
        getDataCabang: function () {

          var kode = localStorage.kodeLevel
          if (this.kode_area != '') {
            kode = this.kode_area
          }
          var req = {kode: kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/cabang'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.cabang = response.body.data.slice()
              for (var i = 0; i < this.cabang.length; i++) {
                this.cabang[i].value = this.cabang[i].kode + ''
                this.cabang[i].label = this.cabang[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        },
        getDataToko: function () {
          // this.loadingModal = true
          // this.tableData = []
          // this.tableData1 = []

          var kode = localStorage.kodeToko
          if (this.kode_cabang != '') {
            kode = this.kode_cabang
          }

          // if (localStorage.level.indexOf('ADMIN') > -1 || localStorage.level.indexOf('KACAB') > -1 || localStorage.level.indexOf('AM') > -1) {
          //   kode = localStorage.kodeToko
          // }

          var req = {kode: kode}
          // var req = {}
          var req1 = JSON.stringify(req)

          // var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/read_simple'
          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/toko'

          // if (localStorage.level.indexOf('ADMIN') > -1 || localStorage.level.indexOf('KACAB') > -1 || localStorage.level.indexOf('AM') > -1) {
          if (localStorage.level.indexOf('ADMIN') > -1 || localStorage.level.indexOf('KACAB') > -1) {
            url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/tokoByAdmin'
          }

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.toko = response.body.data.slice()
              for (var i = 0; i < this.toko.length; i++) {
                this.toko[i].value = this.toko[i].kode + ''
                this.toko[i].label = this.toko[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        }
      },
      mounted () {

        this.tanggal1 = moment(this.value4).format('YYYY-MM-DD')
        this.tanggal2 = moment(this.value5).format('YYYY-MM-DD')

        // this.renderChart(this.chartdataa, this.chartOptions)

        // if (localStorage.username !== 'root') {
        //   this.$router.replace('/toko')
        // }
        // this.loadingModal = true
        // this.getData()
    
        if (localStorage.level.indexOf('BOD') > -1 || localStorage.level.indexOf('KAREGION') > -1 || localStorage.level.indexOf('ROOT') > -1) {          
          this.getDataRegion()
          this.getDataToko()  
          // this.getDataCabang()
          // this.getDataArea()
          // this.getDataWilayah() 
        }
        if (localStorage.level.indexOf('AM') > -1) { this.getDataCabang() }
        if (localStorage.level.indexOf('ADMIN') > -1 || localStorage.level.indexOf('KACAB') > -1) { this.getDataToko() }

        this.chartData = {
          columns: ['Linex', 'Sales'],
          rows: [
            { 'Linex': '5', 'Sales': 0 },
            { 'Linex': '6', 'Sales': 0 },
            { 'Linex': '7', 'Sales': 0 },
            { 'Linex': '8', 'Sales': 0 },
            { 'Linex': '9', 'Sales': 0 },
            { 'Linex': '10', 'Sales': 0 },
            { 'Linex': '11', 'Sales': 0 },
            { 'Linex': '12', 'Sales': 0 },
            { 'Linex': '13', 'Sales': 0 },
            { 'Linex': '14', 'Sales': 0 },
            { 'Linex': '15', 'Sales': 0 },
            { 'Linex': '16', 'Sales': 0 },
            { 'Linex': '17', 'Sales': 0 },
            { 'Linex': '18', 'Sales': 0 },
            { 'Linex': '19', 'Sales': 0 },
            { 'Linex': '20', 'Sales': 0 },
            { 'Linex': '21', 'Sales': 0 },
            { 'Linex': '22', 'Sales': 0 }
          ]
        }
        // this.chartSettings = {
        //   stack: { 'Price': ['Sales', 'Cost', 'COGS', 'Waste'] },
        //   area: true
        // }

        this.barData = {
          columns: ['label','omset'],
          rows: [
            { 'label': 'Buka-09:00', 'omset': 0 },
            { 'label': '09:01-12:00', 'omset': 0 },
            { 'label': '12:01-15:00', 'omset': 0 },
            { 'label': '15:01-18:00', 'omset': 0 }
          ]
        }

        // this.colorList = ['#4f81bd', '#c0504d', '#9bbb59', '#604a7b', '#948a54', '#e46c0b'];
        this.colorList = ['#4f81bd', '#4f81bd', '#4f81bd', '#4f81bd', '#4f81bd'];

        this.barSettings = {
          metrics: ['omset'],
          // showLine: ['cost'],
          label: {
            normal: { show: true, position: 'top' }
          },
          itemStyle: {
            normal: {
              color: (params) => {
                // let colorList = ['#e46c0b', '#c0504d', '#e46c0b', '#604a7b', '#948a54', '#e46c0b'];
                return this.colorList[params.dataIndex]
              }
            }
          }
        }

      },
      watch: {
        'barData' (to, from) {
          this.renderChart(this.barData, this.barSettings)
        }
      }
    }
</script>

<style>
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
  .el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange.is-active {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// Penjualan1.vue?089f559c